import { useFlags } from 'launchdarkly-react-client-sdk';

/**
 * Evaluates a feature flag key
 * @param {import('../common/consts/featureFlags').FeatureFlag} featureFlag
 * @returns {boolean}
 */
export function useFeatureFlag(featureFlag, defaultValue = false) {
  const allFlags = useFlags();

  // Assume all feature flags are enabled in tests for now
  // TODO: figure out a more robust solution to for testing feature flags
  if (window.Cypress) {
    return true;
  }

  return allFlags[featureFlag] || defaultValue;
}
